import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Flex, Image } from '../Base';

const LOGIN_BACKGROUND_SRC = '/assets/images/app/log-in-background.svg';

const BANNER_HEIGHT = 424;
const BACKGROUND_WIDTH = 972;
const BACKGROUND_HEIGHT = 388;

const LoginBannerContainer = styled(Flex)`
  width: 100%;
  height: ${({ $topOffset }) => BANNER_HEIGHT + $topOffset}px;
  padding-top: ${({ $topOffset }) => $topOffset}px;
  align-items: flex-end;
  justify-content: center;
  overflow: hidden;
  background-color: ${({ theme }) => theme.colors.eggSpace.primary[500]};
`;

const LoginBanner = ({ topOffset = 0 }) => (
  <LoginBannerContainer flex={'0 0 auto'} $topOffset={topOffset}>
    <Image
      src={LOGIN_BACKGROUND_SRC}
      alt={'Learn anywhere - eggspace'}
      width={`${BACKGROUND_WIDTH}px`}
      height={`${BACKGROUND_HEIGHT}px`}
      flexShrink={0}
    />
  </LoginBannerContainer>
);

LoginBanner.propTypes = {
  topOffset: PropTypes.number,
};

export default LoginBanner;
